import PROMISED_PAYMENT_API from 'api/promised-payment/v1'
import { startSubmit, SubmissionError } from 'redux-form'
import { call, put, takeLatest } from 'redux-saga/effects'
import extractErrors from 'utils/extractErrors'
import { notificationShow } from 'modules/Notifications/actions'

function* fetchSettings() {
  try {
    yield put({
      type: 'PROMISED_PAYMENT/SETUP_SETTINGS',
      payload: { loadingCreditSettings: true },
    })

    const { response, error } = yield call(PROMISED_PAYMENT_API.fetchSettings)

    if (error) {
      throw error
    }

    yield put({
      type: 'PROMISED_PAYMENT/SETUP_SETTINGS',
      payload: {
        ...response.data,
        loadingCreditSettings: false,
      },
    })
  } catch (error) {
    yield put({
      type: 'PROMISED_PAYMENT/SETUP_SETTINGS',
      payload: { loadingCreditSettings: false },
    })
    yield put(
      notificationShow({
        type: 'error',
        message: 'common::notifications.data_fetch_failed',
      }),
    )
    console.logXHR(error)
  }
}

function* createRequest({
  payload,
  formName,
  meta: { resolve = () => {}, reject = () => {} } = {},
}) {
  try {
    yield put(startSubmit(formName))

    const { error } = yield call(PROMISED_PAYMENT_API.create, {
      data: payload,
    })

    if (error) {
      throw error
    }

    yield put(
      notificationShow({
        type: 'success',
        message: 'promised_payment::notifications.request_successfully_created',
      }),
    )

    resolve()
  } catch (error) {
    const { form, fields } = extractErrors(error.errors)

    reject(fields ? new SubmissionError(fields) : error.statusText)

    if (form) {
      yield put(
        notificationShow({
          type: 'error',
          message:
            form || 'promised_payment::notifications.request_creation_failed',
          delay: 10000,
        }),
      )
    } else {
      yield put(
        notificationShow({
          type: 'error',
          message: form || 'common::notifications.unexpected_error',
        }),
      )
    }
  }
}

export default function* Sagas() {
  yield takeLatest('PROMISED_PAYMENT/FETCH_SETTINGS', fetchSettings)
  yield takeLatest('PROMISED_PAYMENT/CREATE_REQUEST', createRequest)
}
